// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"cf945c7f","123":"31d6cfe0","260":"7e0655a8","656":"f8ea51c1","888":"8eb5b331"}[chunkId] + ".chunk.css";
};